// 207C §4 [RULED — Laurent, 2026-09-24, ruling 8] — A SECTION OPENS AT ITS TOP,
// ITS HEADER IN SIGHT — every person list among them.
//
// Laurent: "when opening the clients section, it shows the client list in the
// middle, and one has to scroll upwards to be able to unlock and tick the +add
// button". The app has ONE scroll pane, `.content` (src/App.css), and nothing
// in src/ ever set it back: `nav()` changes the screen and the pane keeps the
// offset the previous screen was left at. MEASURED on 0921877c (scripts/
// drive-207c.js --part=scroll, both engines) — see 207C §4's commit.
//
// THE RULE, as one decision for every move from one screen to another (a
// screen is a section and, when a record is open, its id):
//   · a section opens at its top — from the sidebar, or from any jump to
//     another section (`nav()`); a record opened from its list opens at its
//     top; a record opened from another record, too;
//   · [ADVISOR] BACK from a record to its own list (« ← Back », or the record
//     closing under it — deleted, archived) returns the list where it was left:
//     the offset the list had when its record was opened is kept for it;
//   · the moves that scroll to a row on arrival (`queueScrollToEv` /
//     `queueScrollToTk` / `scrollToStage`, src/utils.ts — the bell's jumps
//     among them) still land on their row: this runs as the new screen is laid
//     out, and their scroll comes after it (200 ms later, and on retries).
//
// Pure: no DOM. App.tsx applies the answer to `.content`; the recording is
// recordings/207c-section-top.

export interface PaneScreen {
  section: string;
  detailId: unknown;
}

export interface PaneMove {
  /** the offset to give the pane on arrival */
  top: number;
  /** a list's offset to keep while its record is open: [section, offset] */
  keep: readonly [string, number] | null;
}

const isRecord = (s: PaneScreen) => s.detailId !== null && s.detailId !== undefined;

/**
 * Where the pane stands when `next` replaces `prev`.
 * @param byNav    the move was `nav()` — a section opened (the sidebar, a jump)
 * @param leftAt   the pane's offset as `prev` was left
 * @param kept     each list's offset kept while one of its records is open
 */
export function paneOnArrival(prev: PaneScreen, next: PaneScreen, byNav: boolean, leftAt: number, kept: Readonly<Record<string, number>>): PaneMove {
  const sameSection = prev.section === next.section;
  if (sameSection && !isRecord(prev) && isRecord(next)) return { top: 0, keep: [prev.section, leftAt] };
  if (sameSection && isRecord(prev) && !isRecord(next) && !byNav) return { top: kept[next.section] ?? 0, keep: null };
  return { top: 0, keep: null };
}
